import { 
    Cartesian3, 
    GeometryInstance, 
    PolylineGeometry, 
    Primitive,
    ColorGeometryInstanceAttribute,
    PolylineColorAppearance
} from "cesium"
import { changeColor } from '@/utils/custom-utils'

export default class LinePrimitive {

    constructor(options) {
        this.points = []
        this.start = []
        this.end = []
        this.options = Object.assign({
            outlineColor: '#F3F3F3',
            outlineWidth: 2,
            outlineOpacity: 0.5
        }, options)
    }

    setPoints(points, start=[], end=[]) {
        this.points.length = 0
        for(let i=0; i<points.length; i++) {
            this.points.push(...points[i])
        }

        this.start = start
        this.end = end
    }

    getInstances() {
        let geometryInstances = []
        if(!(this.points && this.points.length>0)){
            return geometryInstances
        }

        // 半径线
        if(this.start && this.start.length === 2 && this.end && this.end.length === 2) {
            const radiusPoints = [this.start[0], this.start[1], this.end[0], this.end[1]]
            const radiusInstance = new GeometryInstance({
                geometry: new PolylineGeometry({
                    positions: Cartesian3.fromDegreesArray(radiusPoints),
                    width: this.options.outlineWidth,
                    vertexFormat: PolylineColorAppearance.VERTEX_FORMAT
                }),
                attributes: {
                    color: ColorGeometryInstanceAttribute.fromColor(changeColor(this.options.outlineColor))
                }
            })
            geometryInstances.push(radiusInstance)
        }

        // 边
        const circleOutlineInstance = new GeometryInstance({
            geometry: new PolylineGeometry({
                positions: Cartesian3.fromDegreesArray(this.points),
                width: this.options.outlineWidth,
                vertexFormat: PolylineColorAppearance.VERTEX_FORMAT
            }),
            attributes: {
                color: ColorGeometryInstanceAttribute.fromColor(changeColor(this.options.outlineColor))
            }
        })
        geometryInstances.push(circleOutlineInstance)
        return geometryInstances
    }

    update(context, frameState, commandList) {
        const instances = this.getInstances()
        if(instances.length === 0) {
            return
        }
        this._primitive = new Primitive({
            geometryInstances: instances,
            appearance: new PolylineColorAppearance({
                translucent: true,
                closed: true
            }),
            asynchronous: false,
            releaseGeometryInstances: false
        })
        const primitive = this._primitive
        primitive.update(context, frameState, commandList)
    }
}